<template>
    <div class="air-wampper">
        <div class="air-header">
            <div class="left">
                <div class="left-logo" :class="isDev ? 'title-logo' : 'title-logo-test'" @click="goBackPList"></div>
                <div class="left-name">{{$project.projectData.name}}</div>
            </div>
            <div class="title-list">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="6" v-if="showDigital">数字总图</el-menu-item> 
                    <el-menu-item index="0" :class="menuListproject ? '' : 'not-look'">项目概况</el-menu-item>
                    <el-menu-item index="1" :class="menuListDataBoard ? '' : 'not-look'">数据看板</el-menu-item>
                    <el-menu-item index="2" :class="menuListImageProgress ? '' : 'not-look'">形象进度</el-menu-item>
                    <el-menu-item index="3" :class="menuListSafety ? '' : 'not-look'">安全生产</el-menu-item>
                    <el-menu-item index="4" :class="menuListFigureMoldLinkage ? '' : 'not-look'">图模对照</el-menu-item> 
                    <el-menu-item index="5" :class="menuListpanoramic ? '' : 'not-look'">720全景</el-menu-item> 
                </el-menu>
            </div>
            <div class="title-icon">
                <!-- <i class="icon icon-help"></i>
                <i class="icon icon-search"></i>
                <i class="icon icon-user"></i> -->
                
                <i class="icon icon-exit" @click="logOut"></i>
            </div>
        </div>
        <div class="air-content">
            <ProjectOverview
                v-if="activeIndex==0">
            </ProjectOverview>
            <AirDataBoard 
                v-if="activeIndex==1">
            </AirDataBoard>
            <ImageProgress 
                v-if="activeIndex==2">
            </ImageProgress>
            <Productionsafety 
                v-if="activeIndex==3">
            </Productionsafety>
            <panoramic 
                v-if="activeIndex==5">
            </panoramic>
            <DigitalGeneralDrawing
                v-if="activeIndex==6"
                :isFullscreen="false"
                >
            </DigitalGeneralDrawing>
            <FigureMoldLinkage></FigureMoldLinkage>
        </div>

    </div>
</template>

<script> 
// FigureMoldLinkage  图模对照这个模块是因为模型要提前加载，并且一直存在不进行第二次加载，所以index.vue整个模块使用了v-if这样的方式
import ProjectOverview from '../components/blockComponent/ProjectOverview'
import AirDataBoard from '../components/blockComponent/AirDataBoard'
import ImageProgress from '../components/blockComponent/ImageProgress'
import Productionsafety from '../components/blockComponent/Productionsafety'
import FigureMoldLinkage from '../components/blockComponent/FigureMoldLinkage'
import panoramic from '../components/blockComponent/panoramic'
import DigitalGeneralDrawing from '../components/blockComponent/DigitalGeneralDrawing'
    export default {
        name: 'Index',
        components: {
            ProjectOverview,
            AirDataBoard,  
            ImageProgress,
            Productionsafety,
            FigureMoldLinkage,
            panoramic,
            DigitalGeneralDrawing
        },

        data() {
            return {
                activeName: '0',
                activeIndex: '0',
                showDigital: false,
                menuListproject: false,  // 项目概况
                menuListDataBoard: false, // 数据看板
                menuListImageProgress: false, // 形象进度
                menuListSafety: false, // 安全生产
                menuListFigureMoldLinkage: false, // 图模对照
                menuListpanoramic: false, // 720全景
                isDev: false,  // false为非生产环境，true为生产环境

            }
        },

        created() {
            // 根据url参数显示功能模块
            let menu = this.$common.getQueryVariable('menu');
            if(menu) {
                this.activeIndex = menu;
                this.activeName = menu;
            }

            this.getAllListAxios();
            // 只有机场项目有数字总图模块, 指定显示模块
            if(this.$project.key === '1') {
                this.getDigitalAuthAxios();
            }
        },
        mounted(){
            if(location.href.indexOf('cockpit-dcpmp') > -1){
                this.isDev = true;
            }else{
                this.isDev = false;
            }
        },

        methods: {
            handleSelect(key) {
                let _this = this;
                switch(key){
                    case "0": 
                        _this.getMessage(_this.menuListproject,key);
                        break;
                    case "1": 
                        _this.getMessage(_this.menuListDataBoard,key);
                        break;
                    case "2": 
                        _this.getMessage(_this.menuListImageProgress,key);
                        break;
                    case "3": 
                        _this.getMessage(_this.menuListSafety,key);
                        break;
                    case "4": 
                        _this.getMessage(_this.menuListFigureMoldLinkage,key);
                        break;
                    case "5": 
                        _this.getMessage(_this.menuListpanoramic,key);
                        break;
                    default:
                        _this.activeIndex = key;
                        _this.activeName = key;
                        break
                }

            },
            getMessage(resBool,key){
                let _this = this;
                if(resBool){
                    _this.activeIndex = key;
                    _this.activeName = key;
                }else{
                    _this.$message({
                        showClose: true,
                        message: '当前用户没有此项查看权限',
                        type: 'warning'
                    });
                }
            },
            logOut(){
                this.$confirm('确定退出当前账号', '操作确认', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.replace('/')
                  window.localStorage.removeItem("Token");
                }).catch(() => {
                  window.history.go(1)
                })
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            //获取数字总图查看权限
            getDigitalAuthAxios() {
                let _this = this;
                let url = `${window.pubilc_config.digitalServerurl}/v1/digital/auth/view-auth`
                _this.$common.getTokenRequest()
                    .get(url)
                    .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        if(data.code === 0) {
                            _this.showDigital = data.data.can;
                            let menu = this.$common.getQueryVariable('menu');
                            if(_this.showDigital && !menu) {
                                _this.activeName = '6'
                                _this.activeIndex = '6'
                            }
                        }
                    }
                    }).catch(err=>{
                        console.log(err,'===/v1/digital/auth/view-auth')
                    })
            },
            // 获取项目查看权限
            getAllListAxios() {
                let _this = this;
                let _organizeId = this.$project.projectData.platform.organizeId;
                let _token = window.localStorage.getItem("Token");
                let url = `${window.pubilc_config.webserverurl}/api/User/Role/GetOrgFuncAuth?Token=${_token}&organizeId=${_organizeId}`
                _this.$axios
                    .get(url)
                    .then(res => {
                        if (res.data.Ret == 1 && res.data.Data) {
                            let _data = res.data.Data;
                            _this.menuListproject = _this.filterDataCheckstate(_data,'ScreenCase');
                            _this.menuListDataBoard = _this.filterDataCheckstate(_data,'Screendate');
                            _this.menuListImageProgress = _this.filterDataCheckstate(_data,'Screenimage');
                            _this.menuListSafety = _this.filterDataCheckstate(_data,'Screensafe');
                            _this.menuListFigureMoldLinkage = _this.filterDataCheckstate(_data,'Screenartwork');
                            _this.menuListpanoramic = _this.filterDataCheckstate(_data,'Screenpanorama');
                            console.log(_this.menuListproject,_this.menuListDataBoard,_this.menuListSafety )
                        }else{
                           _this.$message.error(res.data.Msg); 
                            this.$router.replace('/')
                            window.localStorage.removeItem("Token"); 
                        }
                    }).catch(err=>{
                        console.log(err,'===/api/User/Role/GetOrgFuncAuth')
                    })
            },
            filterDataCheckstate(data,_name){
                let _obj = data.filter(item => item.Bm_EnCode == _name)
                let _bool = null;
                _obj[0].checkstate == "1" ? _bool = true : _bool = false;
                return _bool;
            },
            // 返回项目列表
            goBackPList() {
                this.$router.replace('/plist')
            }
        },
    }
</script>
 
<style scoped>
@import "../assets/css/header.css";
.air-header /deep/ .el-menu{
    background: transparent;
}
.air-header /deep/ .el-menu.el-menu--horizontal{
    border: none;
}
.air-header /deep/ .el-menu--horizontal > .el-menu-item.is-active{
    border-bottom: 4px solid #2899FF;
    color: #2899FF;
}
.air-header /deep/ .el-menu--horizontal > .el-menu-item.is-active.not-look{
    border-bottom: 4px solid #4a4a4a;
    color: #4a4a4a;
}
.air-header /deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus.not-look{
    color: #4a4a4a;
}
.air-header /deep/ .el-menu--horizontal > .el-menu-item{
    height: 80px;
    line-height: 80px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: rgba(255, 255, 255, 0.72);
    
}
.air-header /deep/ .el-menu-item{
    font-size: 22px;
}
.air-header /deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, 
.air-header /deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
    color: rgba(40, 153, 255, 1);
    background-color: transparent;
}
.air-content /deep/ .el-tabs__header{
    margin: 0;
    height: 0;
}
.air-content /deep/ .el-tabs__nav-wrap::after{
    content: "";
    height: 0;
}
#liquidfill-chart {
    width: 100%;
    height: 140px;
    margin-bottom: 10px;
}
.air-header /deep/ .el-menu-demo .not-look{
    color: #666666;
    cursor: not-allowed;
}
.title-logo {
  width: 483px;
  height: 62px;
  /* margin: 9px 20px; */
  margin: 14px 20px 4px;
  background-repeat: no-repeat;
  background-image: url("../assets/images/title.png");
  background-size: 100%;
}
.title-logo-test {
    width: 483px;
    height: 62px;
    /* margin: 9px 20px; */
    margin: 25px 10px 0px;
    background-repeat: no-repeat;
    background-image: url("../assets/images/title-test.png");
    background-size: 100%;
}
.air-header {
    position: relative;
    width: 100%;
}
/* .title-list {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
} */
.left {
    position: relative;
    width: 500px;
    height: 80px;
}
.left-logo {
    position: absolute;
    left: 4px;
    top: -6px;
}
.left-name {
    position: absolute;
    left: 94px;
    top: 50px;
    font-size: 16px;
    font-weight: bold;
    color: #26abff;
    white-space: nowrap;
}
</style>
